export default "__VITE_ASSET__BWQuEQZU__"